import { useLogoutMutation } from 'services/auth/auth';

import { selectUser } from 'store';
import { clearUser } from 'store/user/userSlice';

import { local, LOCAL_KEYS, session } from 'utils/storage';
import { clearWorkOSCookies } from 'utils/workos';

import { clearPrograms } from 'store/programs/programsSlice';
import { useAppDispatch, useAppSelector, useMessages, useZoomCall } from '../index';

/**
 * Provides a logout handler that triggers the logout mutation and clears user-related state and storage.
 *
 * @returns Function that signs the user out, resets Zoom state when present, and cleans local storage.
 */
export const useLogout = () => {
  const { loggerClient, resetValuesToDefault, room } = useZoomCall();
  const [logout] = useLogoutMutation();
  const user = useAppSelector(selectUser);
  const dispatch = useAppDispatch();
  const { clearChannels } = useMessages();

  const handleClearStore = async (cb?: () => void) => {
    if (room) {
      await loggerClient?.reportToGlobalTracing();
      resetValuesToDefault();
    }
    local.set(LOCAL_KEYS.LOGOUT_EVENT, 'logout' + Math.random());
    dispatch(clearUser());
    clearChannels();
    dispatch(clearPrograms());
    session.clear();
    clearWorkOSCookies();
    cb?.();
  };

  return (cb?: () => void) => {
    logout(user.accessToken)
      .unwrap()
      .finally(() => handleClearStore(cb));
  };
};
